import type { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/utils/routerHelper'

const businessRoutes: RouteRecordRaw[] = [
  {
    path: '/business',
    name: 'Business',
    component: Layout,
    meta: {
      title: '商户管理',
      icon: 'vi-ep:shop',
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/Business/BusinessList.vue'),
        name: 'BusinessList',
        meta: { title: '商户列表' }
      },
      {
        path: 'application',
        component: () => import('@/views/Business/ApplicationList.vue'),
        name: 'BusinessApplicationList',
        meta: { title: '项目管理' }
      },
      {
        path: 'notify',
        component: () => import('@/views/Business/NotifyList.vue'),
        name: 'BusinessNotifyList',
        meta: { title: '回调地址' }
      }
    ]
  }
]

export default businessRoutes
